import React from 'react';
import { useSelector } from 'react-redux';
import { getChipFeedState } from '../store/selectors/chipFeedSelector';
import ChipFeedInDfv from '../ChipFeedInDfv';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import chipFeedReducer from '../store/reducers/chipFeed';
import { getCommercialBreakState } from '../../Ads/store/selectors/commercialBreak';

initContainerData.register({
    reducers: {
        chipFeed: chipFeedReducer
    }
});

const ChipFeedInDfvDataContainer = () => {
    const chipFeedState = useSelector(getChipFeedState);
    const { showMidInnigAd, adStarted } = useSelector(getCommercialBreakState);

    if (showMidInnigAd && adStarted) {
        return null;
    }

    return (
        <ChipFeedInDfv { ...chipFeedState }/>
    );
};

export default ChipFeedInDfvDataContainer;
